import { getCurrentUserId } from "@gtmhub/users";

/*
 * Returns true if the current user is (co-)owner of the metric.
 * The current user is the owner of the metric if he is the owner of the metric or if he is a member of the team that is owner of the metric.
 * @param ownerIds - the ids of the metric owners and teams that are owners of the metric
 * @param currentUserTeamIds - the ids of the teams the current user is a member of. To this list we add the current user id as well!
 * @returns true if the current user is the owner of the metric
 * */
export const isCurrentUserOwner = (ownerIds: string[], currentUserTeamIds: string[]): boolean => {
  const currentUserAndRoleIds = [getCurrentUserId(), ...currentUserTeamIds];
  return ownerIds.some((r) => currentUserAndRoleIds.includes(r));
};
